import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_component_is_mounted } from './use_component_is_mounted';

export function use_component_is_mounted_300() {
  return use_component_is_mounted(CONSTANTS_TIME__client.MS_300, () => {});
}
